import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { FormControlContainer } from '../../../components/formControlContainer';
import { BlindsControlContainer } from './blindsControlContainer';
import { GameSpeedControl } from './gameSpeedControl';
import { NumSeatsControlContainer } from './numSeatsControlContainer';
export const MiscGameSettingsControlSet = () => {
    return (_jsxs(FormControlContainer, { isFlex: true, children: [_jsx(GameSpeedControl, {}), _jsx(NumSeatsControlContainer, {}), _jsx(BlindsControlContainer, {})] }));
};
